import connect from './connect'
import CreateClientPage from './CreateClientPage'

export default connect(CreateClientPage)
